<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Edit Task</span>
      </v-card-title>
      <v-card-text>
        <v-text-field ref="detailsField" label="Details" v-model="editedTask.details" :rules="[rules.lengthRule]"></v-text-field>
        <v-select label="Assigned To" :items="taggedOptions" v-model="editedTask.tagged"></v-select>
        <v-menu v-model="menu" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="isoDateToCommonDate(editedTask.dueDate)"
              label="Due Date"
              persistent-hint
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="editedTask.dueDate = null"
            ></v-text-field>
          </template>
          <v-date-picker v-model="editedTask.dueDate" @change="menu = false" :allowed-dates="allowedDates"></v-date-picker>
        </v-menu>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!changes" color="primary" @click="save">Save</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { addDays, format, isFuture, isToday, parseISO } from 'date-fns'
import dateHelper from '@/mixins/date-helper'

export default {
  mixins: [dateHelper],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    task: {
      type: Object,
      required: false,
    },
    taggedOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      editedTask: {},
      backupTask: {},
      rules: {
        lengthRule: value => (value != null && value.length >= 5 && value.length <= 200) || 'Must be between 5 and 250 characters',
      },
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.editedTask = { ...this.task, dueDate: this.formatDueDate(this.task.dueEpoch) }
        this.backupTask = JSON.stringify(this.editedTask)
      }
    },
  },
  methods: {
    save() {
      if (this.$refs.detailsField.validate()) {
        if (this.editedTask.dueDate) {
          this.editedTask.dueEpoch = parseISO(this.editedTask.dueDate).getTime()
        } else {
          this.editedTask.dueEpoch = null
        }
        this.$emit('save', this.editedTask)
      }
    },
    cancel() {
      this.dialog = false
    },
    formatDueDate(date) {
      if (date) {
        return format(new Date(date), 'yyyy-MM-dd')
      }
      return null
    },
    allowedDates(date) {
      const compareTo = addDays(new Date(date), 1)
      return isToday(compareTo) || isFuture(compareTo)
    },
  },
  computed: {
    dialog: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    changes() {
      return JSON.stringify(this.editedTask) !== this.backupTask
    },
  },
}
</script>
